/*

NOTE: Unresolved Webpack issue: webpack module loading semantics are dependent
on the level of nesting of object composition that exists around instances of
importing classes.

For example if a view-model imports RQuery modules at the level of a page
nested in an outer tab-control view model, then two argument calls to require
work properly; whereas when imported via a view-model which backs a top level
page, two argument calls to require break, and attempts to register any
relevant imports in global scope silently fail until runtime.

Two argument calls to require are therefore replaced with script tag includes
in index.html for now.

*/

/* Broken Webpack module loading semantics */
//require(["./jquery.js"], function (jq) { window.$ = window.jQuery = jq; });

require("./RQueryREST.js");
require("./RQueryRESTParams.js");
require("./RQueryRESTHandlers.js");
require("./RQueryRESTStdMethodBindings.js");
require("./RQueryRESTServiceHelper.js");

module.exports.RQParam    = RQParam;
module.exports.RQHandlers = RQHandlers;
module.exports.RQService  = RQService;
module.exports.RQApp      = RQApp;


//////////////////
// WEBPACK FOOTER
// ./src/RQuery/RQuery.js
// module id = 5
// module chunks = 0